import Author from "../../../../common/model/Author";

export default interface EmployeeImportJob {
  id: number;
  source: string;
  source_id: string;
  user_uploaded: Author;
  status: string;
  status_reason: string;
  total_count: number;
  valid_count: number;
  invalid_count: number;
  will_create_count: number;
  will_update_count: number;
  did_create_count: number;
  did_update_count: number;
  identical_count: number;
  failure_count: number;
  sla_deadline: string;
  date_created: string;
  date_updated: string;
  date_finalised: string;
}

export const EmployeeImportJobStatus = {
  CREATED: "created",
  ANALYSING: "analysing",
  ANALYSED: "analysed",
  PROCESSING: "processing",
  COMPLETED_WITH_ERRORS: "completed_with_errors",
  COMPLETED: "completed",
  FAILED: "failed",
  CANCELLED: "cancelled",
};

export interface EmployeeImportJobWrapper {
  count: number;
  pages: number;
  results: EmployeeImportJob[];
}
